require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-update-why-country-forest-notes-why-now.json") })
        }
      }, "path---en-us-update-why-country-forest-notes-why-now");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-update-why-country-forest-notes-why-now!./.cache/json/en-us-update-why-country-forest-notes-why-now.json
// module id = 862
// module chunks = 231608221292675